{
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "sign_up": "Registrar",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral"
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticación",
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "users": "Usuarios",
    "projects": "Empresas",
    "sales-funnel": "Embudo de Venta",
    "empleados-empresarial": "Lista Empleados Empresarial",
    "convenios": "Convenios",
    "funerarias": "Funerarias",
    "payments": "Planes / Pagos",
    "payment-methods": "Medios Pagos",
    "pricing-plans": "Planes Empresarial",
    "billing": "Facturación",
    "login": "Iniciar sesión",
    "support": "Soporte",
    "support-tickets": "Tickets y notas",
    "preferences": "Preferencias",
    "login-singup": "Iniciar sesión/Registrarse",
    "404": "Páginas 404",
    "faq": "FAQ",
    "settings": "Configuración del sistema"
  },
  "embudo": {
    "pageTitle": "Embudo de Ventas",
    "bannerTitle": "Embudo de Ventas — Proceso Plan Empresarial",
    "bannerSubtitle": "7 etapas incluyendo Cerrado Ganado y Cerrado Perdido",
    "emptyColumn": "Sin empresas",
    "newCompany": "Nueva Empresa",
    "toolbarGestion": "Gestión empresa",
    "gestionPickerPlaceholder": "Elige empresa…",
    "pickCompanyFirst": "Elige una empresa en la lista para abrir su gestión.",
    "summary": {
      "title": "Seguimiento",
      "empty": "Sin datos de seguimiento — usa Gestión empresa",
      "estatus": "Estatus",
      "gestion": "Gestión",
      "ciudad": "Ciudad",
      "ultimaActividad": "Última actividad",
      "proximo": "Próximo paso"
    },
    "hint": "Arrastra una empresa a otra columna para cambiar de etapa.",
    "saveError": "No se pudo guardar la etapa. Intenta de nuevo.",
    "stages": {
      "base_datos": "BASE DE DATOS",
      "activar": "ACTIVAR",
      "estrechar": "ESTRECHAR",
      "pronostico": "PRONÓSTICO",
      "post_venta": "POST VENTA",
      "cerrado_ganado": "CERRADO GANADO",
      "cerrado_perdido": "CERRADO PERDIDO"
    },
    "gestion": {
      "title": "Gestión Empresa",
      "selectPlaceholder": "— Seleccionar —",
      "sectionGeneral": "Datos generales",
      "sectionContacto": "Contacto",
      "sectionEmbudo": "Embudo y actividades",
      "sectionCrm": "Campos CRM (Salesforce)",
      "empresa": "Empresa",
      "tipo": "Tipo",
      "tipoGestion": "Tipo de gestión",
      "ciudad": "Ciudad",
      "ciudadPh": "Ej: Ciudad Juárez",
      "estatus": "Estatus",
      "nombreContacto": "Nombre contacto",
      "correo": "Correo",
      "telefono": "Teléfono",
      "telefonoPh": "10 dígitos",
      "telefonoRequired": "El teléfono es obligatorio",
      "telefono10Digits": "El teléfono debe tener exactamente 10 dígitos",
      "telefonoSaveError": "Indica un teléfono de 10 dígitos antes de guardar",
      "fechaContacto": "Fecha contacto",
      "etapaEmbudo": "Etapa del embudo",
      "actividades": "Actividades",
      "agregar": "+ Agregar",
      "descripcionPh": "Descripción…",
      "proximoPaso": "Próximo paso",
      "numEmpleados": "Núm. empleados",
      "motivoPerdido": "Motivo si perdido",
      "motivoPerdidoPh": "Razón de descarte",
      "origenLead": "Origen del lead",
      "montoEstimado": "Monto estimado ($)",
      "fechaCierreEstimada": "Fecha cierre estimada",
      "probabilidad": "Probabilidad (%)",
      "asesorId": "ID asesor",
      "correoAsesor": "Correo asesor",
      "siguientePasoCrm": "Siguiente paso (CRM)",
      "siguientePasoCrmPh": "Acción concreta a tomar",
      "notas": "Notas",
      "cancelar": "Cancelar",
      "guardar": "Guardar",
      "saveOk": "Seguimiento guardado",
      "saveError": "No se pudo guardar"
    },
    "gestionEmpresa": "Gestión empresa"
  },
  "empleadosEmp": {
    "title": "Lista Empleados Empresarial",
    "searchPh": "Buscar por nombre, RFC, correo…",
    "downloadTemplate": "Plantilla CSV",
    "uploadCsv": "Subir CSV",
    "add": "Agregar registro",
    "editTitle": "Editar empleado",
    "newTitle": "Nuevo empleado",
    "save": "Guardar",
    "create": "Crear",
    "savedUpdate": "Registro actualizado",
    "savedCreate": "Registro creado",
    "errorLoad": "No se pudo cargar la lista",
    "errorSave": "No se pudo guardar",
    "errorDelete": "No se pudo eliminar",
    "deleteTitle": "Eliminar registro",
    "deleteMsg": "¿Eliminar el registro de {nombre}?",
    "deleteOk": "Eliminar",
    "deleted": "Registro eliminado",
    "csvEmpty": "El CSV no tiene filas de datos",
    "csvOk": "Se importaron {n} registros",
    "csvError": "Error al importar CSV",
    "unsavedClose": "Hay cambios sin guardar. ¿Cerrar de todos modos?"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema"
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración del sistema",
    "billing": "Facturación",
    "faq": "Preguntas Frecuentes",
    "helpAndSupport": "Ayuda & Soporte",
    "projects": "Proyectos",
    "account": "Cuenta",
    "explore": "Explorar"
  },
  "helpAndSupport": "Ayuda y Soporte",
  "settingsPage": {
    "title": "Configuración del sistema",
    "theme": "Tema",
    "themeDark": "Oscuro",
    "themeLight": "Claro",
    "themeMausoleo": "Mausoleo",
    "generalPreferences": "Preferencias generales",
    "language": "Idioma",
    "notificationsAlertTitle": "Tus preferencias de notificación están agrupadas y simplificadas",
    "notificationsAlertText": "Tus opciones anteriores no se han modificado.",
    "notificationsSectionTitle": "Notificaciones que recibes"
  },
  "aboutVuesticAdmin": "Acerca de CRM Empresarial",
  "aboutCrmManualPending": "Pendiente subir Manual de usuario.",
  "supportAndConsulting": "Contactanos",
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Subir archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Seleccionar una opción"
  }
}
